import {
    SURVEY_YEAR_2022_2023,
    SURVEY_YEAR_2023,
    SURVEY_YEAR_2023_2024,
    SURVEY_YEAR_2024,
    SURVEY_YEAR_2024_2025,
    SURVEY_YEAR_2025,
    SURVEY_YEAR_2025_2026_PRELIM,
    SURVEY_YEAR_2025_2026,
    SURVEY_YEAR_2026_PRELIM,
    SURVEY_YEAR_2026,
    SURVEY_YEAR_2026_2027_PRELIM,
    SURVEY_YEAR_2026_2027,
    SURVEY_YEAR_2027_PRELIM,
} from './constants'

const PRACTICE_NORTH_AMERICA_COUNTRY_LIST = {
    [SURVEY_YEAR_2022_2023]: [
        { value: 'United States', label: 'United States' },
        { value: 'Canada', label: 'Canada' },
    ],
}

const PRACTICE_EUROPE_COUNTRY_LIST = {
    [SURVEY_YEAR_2022_2023]: [
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },

        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2023]: [
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
}

const PRACTICE_GLOBAL_COUNTRY_LIST = {
    [SURVEY_YEAR_2022_2023]: [
        { value: 'Global', label: 'Global: All Countries' },
    ],
}

export const PRACTICE_GROUPED_COUNTRY_OPTIONS = {
    [SURVEY_YEAR_2022_2023]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],

    [SURVEY_YEAR_2023]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2023_2024]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2024]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2024_2025]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2025]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2025_2026_PRELIM]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2025_2026]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2026_PRELIM]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2026]: [
        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2026_2027_PRELIM]: [

        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2026_2027]: [

        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
    [SURVEY_YEAR_2027_PRELIM]: [

        {
            label: 'Global',
            options: PRACTICE_GLOBAL_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'North America',
            options: PRACTICE_NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },

        {
            label: 'Europe',
            options: PRACTICE_EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
    ],
}